import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Swal from 'sweetalert2';


import { userActions } from '../../../_actions';

import opptimise_logo_big from '../../../images/opptimise_logo_big.png';


import 'bootstrap/dist/css/bootstrap.min.css';
import '../LoginPage/login.css';

class SetPassword extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        // this.props.dispatch(userActions.logout());

        this.state = {
            email: '',
            confirmPassword: '',
            password: '',
            submitted: false,
            passwordCheck: false,

            hashCode: false,
            loadHashCode: true

        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        let setPassWordHashCode = this.props.location.pathname.split('/');
        
        let combineHashCode = `${setPassWordHashCode[setPassWordHashCode.length - 3 ]}/${setPassWordHashCode[setPassWordHashCode.length - 2]}`
        
        let data = {
            hashCode: combineHashCode,
            data : {}
        }
        this.props.dispatch(userActions.setPasswordHandler(data, 'get',(setPasswordHandler_Res) => {
            if(!setPasswordHandler_Res) {
                this.setState({
                    hashCode: false,
                    loadHashCode: false
                })
            }else {
                if(setPasswordHandler_Res.data.status) {
                    this.setState({
                        hashCode: true,
                        loadHashCode: false
                    })
                }else {
                    this.setState({
                        hashCode: false,
                        loadHashCode: false
                    })
                }
            }
        }));
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        let setPassWordHashCode = this.props.location.pathname.split('/');
        
        let combineHashCode = `${setPassWordHashCode[setPassWordHashCode.length - 3 ]}/${setPassWordHashCode[setPassWordHashCode.length - 2]}`
        
        const data = {
            hashCode: combineHashCode,
            data: {
                password: this.state.password
            }
        }

        if (this.state.password !== this.state.confirmPassword) {
            this.setState({ passwordCheck: true })

        } else {
            this.setState({ passwordCheck: false })
            this.props.dispatch(userActions.setPasswordHandler(data, 'post',(setPasswordHandler_Res) => {
                if(setPasswordHandler_Res.data.status) {
                    Swal({
                        text: setPasswordHandler_Res.data.message,
                        type: 'success',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    })
                    .then(result => {
                        this.props.history.push('/login')
                    })
                }
            }));
        }

    }

    // componentDidUpdate(prevProps) {
    //     if(prevProps.setPasswordReducerMain !== this.props.setPasswordReducerMain) {
    //         if(!this.props.setPasswordReducerMain.setPasswordLoad !== this.props.setPasswordReducerMain.setPasswordError) {
    //             if(this.props.setPasswordReducerMain.setPasswordData.status === true) {
    //                 if(this.state.submitted) {
    //                     swal({
    //                         text: this.props.setPasswordReducerMain.setPasswordData.message,
    //                         type: 'success',
    //                         confirmButtonColor: '#3085d6',
    //                         confirmButtonText: 'OK'
    //                     })
    //                     setTimeout(() => {
    //                         window.location.reload();
    //                         history.push('/login');
    //                     }, 1000);
    //                 }
    //             }
    //         }
    //     }
    // }

    render() {
        // const { alert } = this.props;
        // const { loggingIn } = this.props;
        // const {setPasswordReducerMain} = this.props;
        const { password, confirmPassword, submitted, passwordCheck, email } = this.state;
        return (
            <div className="login-page text-white">
               <div className="text-md-left py-3  px-md-5" style={{width: 'max-content'}}>
                    <div className="d-flex justify-content-center align-items-center py-2">
                        <img src={opptimise_logo_big} style={{width: 70}} />
                    </div>
                    <h5>Behavioral Analytics</h5>
                </div>

                <div className="container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                {
                                    // !setPasswordReducerMain.setPasswordLoad && !setPasswordReducerMain.setPasswordError && 
                                        <p className="text-center py-3 py-lg-2">Set Password</p>
                                }

                                {
                                    passwordCheck &&
                                    <p className="text-center">"Confirm Password" does not match Password</p>
                                }
                                <div className="">
                                    {
                                        // !setPasswordReducerMain.setPasswordLoad ? 
                                        //     !setPasswordReducerMain.setPasswordError ?
                                            !this.state.loadHashCode ?
                                                this.state.hashCode ?
                                                <form
                                                    method="post"
                                                    onSubmit={
                                                        this.handleSubmit
                                                    }
                                                >
                                                    {/* <div className="form-group">
                                                        <label htmlFor="email" className="text-uppercase"><small>EMAIL ID</small></label>
                                                        <input
                                                            type="email" className="form-control" id="email" placeholder="name@company.com"
                                                            name="email"
                                                            required
                                                            value={email}
                                                            onChange={this.handleChange}
                                                        />
                                                        {submitted && !email &&
                                                            <div className="help-block">Email is required</div>
                                                        }
                                                    </div> */}
                                                    <div className="form-group">
                                                        <label htmlFor="password" className="text-uppercase"><small>password</small></label>
                                                        <input
                                                            type="password" className="form-control" id="password" placeholder="password"
                                                            name="password"
                                                            required
                                                            value={password}
                                                            onChange={this.handleChange}
                                                        />
                                                        {submitted && !password &&
                                                            <div className="help-block">password is required</div>
                                                        }
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="inputPassword4" className="text-uppercase"><small>Confirm Password</small></label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            id="inputPassword4"
                                                            placeholder="confirmPassword"
                                                            name="confirmPassword"
                                                            required
                                                            value={confirmPassword}
                                                            onChange={this.handleChange}
                                                        />
                                                        {
                                                            submitted && !confirmPassword &&
                                                            <div className="help-block">Confirm Password is required</div>
                                                        }
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="text-center">
                                                            <button
                                                                type="submit"
                                                                className="btn buttonColor btn-sm text-white px-3"
                                                            >
                                                                <small>SET PASSWORD</small>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {/* <div className="text-center">
                                                        <a href="#" className=" text-white anchor-decoration">Forgot Password?</a>
                                                    </div> */}

                                                </form>
                                                :
                                                <LinkExpired history={this.props.history} />
                                            :
                                                null
                                        //     :
                                        //     <LinkExpired />
                                    }
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const LinkExpired = (props) => (
    <div>
        <h3 className="expiry-link-heading" style={{textAlign:'center'}}>This link has expired</h3>
        <div className="invalid-link-reasons">
            <p>This could be because:</p>
            <ol>
                <li>You have a newer link. In this case, check your email inbox.</li>
                <li>You have already created a password. Go to the login page to continue.</li>
                <li>It's been more than 24 hours since you received the link. Go to the login page and click "forgot password" to generate a new link.</li>
            </ol>
        </div>
        <div style={{textAlign:'center'}}>
            <button className="btn btn-red btn-sm text-uppercase" onClick={() => {props.history.push('/login')}}>GO BACK</button>
        </div>
    </div>
)

function mapStateToProps(state) {
    // const { loggingIn } = state.authentication;
    // const { alert } = state;
    // return {
    //     // loggingIn,
    //     // alert
    // };
    return state;
}

const connectedSetPassword = connect(mapStateToProps)(SetPassword);
export { connectedSetPassword as SetPassword }; 



// WEBPACK FOOTER //
// ./src/_components/common/SetPassword/index.jsx